import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import { Box, Skeleton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const StyledCellHeader = styled(TableCell)({
  borderBottom: "none",
  color: "#637381",
  backgroundColor: "#f4f6f8",
  "&:first-of-type": {
    paddingLeft: 24,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    boxShadow: "20px -10px 20p #EEEEEE",
    position: "sticky",
    left: 0,
    backgroundColor: "#f4f6f8",
    zIndex: 4,
  },
  "&:last-of-type": {
    paddingRight: 24,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
});

const StyledCellContent = styled(TableCell)({
  borderBottom: "none",
  padding: 16,
  "&.sticky": {
    position: "sticky",
    left: 0,
    backgroundColor: "#FFFFFF",
    boxShadow: "8px 20px 20px #EEEEEE",
  },
  "&:first-of-type": {
    paddingLeft: 24,
  },
  "&:last-of-type": {
    paddingRight: 24,
  },
});

const ManagerApproveSettingTable = () => {

  const { result: ManagerApproveSettingData, isFetching } = useSelector(state => state.managerApproveSetting);

  const groupByTopic = (data) => {
    const grouped = {};
    data.forEach(item => {
      if (!grouped[item.idManagerApproveTopic]) {
        grouped[item.idManagerApproveTopic] = {
          idManagerApproveTopic: item.idManagerApproveTopic,
          managerApproveTopicName: item.managerApproveTopicName,
          types: []
        };
      }
      grouped[item.idManagerApproveTopic].types.push({
        idManagerApproveType: item.idManagerApproveType,
        managerApproveTypeName: item.managerApproveTypeName,
        isManagerLv1: !!item.isManagerLv1,
        isManagerLv2: !!item.isManagerLv2,
      });
    });
    return Object.values(grouped);
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledCellHeader>ประเภทการอนุมัติ</StyledCellHeader>
            <StyledCellHeader align="center">หัวหน้างานระดับที่ 1</StyledCellHeader>
            <StyledCellHeader align="center">หัวหน้างานระดับที่ 2</StyledCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {isFetching? (
            [...Array(3)].map((_, idx) => (
            <TableRow key={idx}>
              <StyledCellContent>
                <Skeleton variant="rectangular" width="80%" height={24} />
              </StyledCellContent>
              <StyledCellContent>
                <Skeleton variant="rectangular" width="60%" height={24} />
              </StyledCellContent>
              <StyledCellContent>
                <Skeleton variant="rectangular" width="60%" height={24} />
              </StyledCellContent>
            </TableRow>
          ))
          ) : ManagerApproveSettingData && ManagerApproveSettingData.length > 0 ? (
            groupByTopic(ManagerApproveSettingData).map(topic => (
              <Fragment key={topic.idManagerApproveTopic}>
                <TableRow>
                  <StyledCellContent colSpan={3}>
                    <Typography fontWeight="500" fontSize="18px">
                      {topic.managerApproveTopicName}
                    </Typography>
                  </StyledCellContent>
                </TableRow>

                {topic.types.map(type => (
                  <TableRow key={type.idManagerApproveType}>
                    <StyledCellContent>
                      <Box paddingLeft="16px">
                        {type.managerApproveTypeName}
                      </Box>
                    </StyledCellContent>
                    <StyledCellContent align="center">
                      {type.isManagerLv1 ? <CheckCircleRoundedIcon color="success" /> : null}
                    </StyledCellContent>
                    <StyledCellContent align="center">
                      {type.isManagerLv2 ? <CheckCircleRoundedIcon color="success" /> : null}
                    </StyledCellContent>
                  </TableRow>
                ))}
              </Fragment>
            ))
          ) : (
            <TableRow>
              <StyledCellContent colSpan={3} align="center">
                <Typography fontSize="20px" color="text.secondary" fontStyle="oblique">ไม่มีข้อมูลการตั้งค่า</Typography>
              </StyledCellContent>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ManagerApproveSettingTable;